import React from 'react';
import { Avatar, Tooltip } from '@material-ui/core';
import { _ } from '~/dependencies';
import { truncate } from '~/helpers';
import StatusBadge from '../StatusBadge';
import { Agents, AgentState } from '../utils';
import { SectionHeader, Agent, Info, NameInitials, Details } from './styles';

type Props = Partial<{
  title: string;
  agents: Agents;
  actions: any;
  agentNameMaxLength: number;
}> &
  AgentState;

const List = (props: Props) => {
  const {
    title,
    agents,
    favorite,
    loading,
    actions,
    addFavoriteAgent,
    agentNameMaxLength,
  } = props;

  return (
    <>
      <div className="list--header">
        <SectionHeader className="line-header">
          <div className="line" />
          <span>{title}</span>
          <div className="line" />
        </SectionHeader>
      </div>

      {agents &&
        _.map(agents, (agent: any) => (
          <Agent key={agent.number} id={agent.number}>
            <Info>
              <NameInitials>
                <Avatar className="agent-icon">
                  {agent.name ? agent.name.slice(0, 2).toUpperCase() : '-'}
                </Avatar>
              </NameInitials>

              <StatusBadge status={agent.status} />
            </Info>

            <Tooltip
              title={agent.name || agent.number}
              placement="bottom-start">
              <Details>
                <span className="agent-number">{agent.number}</span>
                <span className="agent-name">
                  {truncate(agent.name, agentNameMaxLength)}
                </span>
              </Details>
            </Tooltip>

            <div className="agent-actions">
              {typeof actions === 'function'
                ? actions({
                    agent,
                    favorite,
                    loading,
                    addFavoriteAgent,
                  })
                : React.Children.map(actions, child =>
                    React.cloneElement(child, {
                      agent,
                      favorite,
                      loading,
                      addFavoriteAgent,
                    })
                  )}
            </div>
          </Agent>
        ))}
    </>
  );
};

List.defaultProps = {
  favorite: false,
};

export default List;
